import { useMemo } from "react";
import { useGetAllMerchants } from "../../../hooks/queries/useMerchantQueries";

export const useMerchantData = () => {
  const {
    data: merchants = [],
    isLoading,
    isError,
    error,
    refetch,
  } = useGetAllMerchants();

  const noMerchants = useMemo(
    () => merchants.length === 0,
    [merchants.length]
  );

  return {
    merchants,
    isLoading,
    isError,
    error,
    refetch,
    noMerchants,
  };
};

export default useMerchantData;
